import React from 'react';
import ReactDOM from 'react-dom';
import 'assets/styles/index.scss';
import App from 'App';

// import { enableSnowplow } from '@cloudcar-app/analytic-tool';
// import trackersConfig from './snowplow_config';

// const COLLECTOR_ADDRESS: string = process.env.REACT_APP_COLLECTOR_ADDRESS ?? '';

// enableSnowplow(COLLECTOR_ADDRESS, trackersConfig);

ReactDOM.render(<App />, document.getElementById('root'));
